import { useRoute, match, navigate } from "@/lib/router";
import { Layout } from "@/components/layout/Layout";
import { HomePage } from "@/pages/HomePage";
import { CategoryListPage } from "@/pages/CategoryListPage";
import { ProjectDetailPage } from "@/pages/ProjectDetailPage";
import { WinnersListPage } from "@/pages/WinnersListPage";
import { LoginPage, RegisterPage, ForgotPasswordPage } from "@/pages/AuthPages";
import { MePage } from "@/pages/MePage";
import { AdminDashboard } from "@/pages/AdminPages";
import { PricingPage } from "@/pages/PricingPage";
import {
  AdminCategoriesPage, AdminProjectsPage, AdminPaywallPage, AdminPlansPage,
  AdminPointPackagesPage,
  AdminApiKeysPage, AdminUsersPage, AdminSettingsPage, AdminMaintenancePage,
  AdminAnalyticsPage,
} from "@/pages/admin/AdminPanels";
import { AdminCrawlerDocsPage } from "@/pages/admin/AdminCrawlerDocsPage";
import { AdminGuard } from "@/pages/admin/AdminGuard";
import { AdminCheckinPage } from "@/pages/AdminCheckinPage";
import { AdminAnnouncementsPage } from "@/pages/AdminAnnouncementsPage";
import { AdminRedeemCodesPage } from "@/pages/AdminRedeemCodesPage";
import { AdminInboxSendPage } from "@/pages/AdminInboxSendPage";
import { DialogHost } from "@/components/ui/dialog";
import { WelcomeGiftDialog } from "@/components/WelcomeGiftDialog";
import "./index.css";

export function App() {
  const route = useRoute();
  return <>
    <Layout>{render(route.path)}</Layout>
    <DialogHost />
    <WelcomeGiftDialog />
  </>;
}

function render(path: string) {
  if (path === "/" || path === "") return <HomePage />;
  if (path === "/login") return <LoginPage />;
  if (path === "/register") return <RegisterPage />;
  if (path === "/forgot") return <ForgotPasswordPage />;
  if (path === "/me") return <MePage />;
  if (path === "/wallet") { navigate("/me", { tab: "wallet" }); return <MePage />; }
  if (path === "/pricing") return <PricingPage />;
  if (path === "/winners") return <WinnersListPage />;
  if (path === "/search") return <CategoryListPage slug="" />;

  if (path.startsWith("/admin")) {
    const inner =
      path === "/admin" ? <AdminDashboard /> :
      path === "/admin/categories" ? <AdminCategoriesPage /> :
      path === "/admin/projects" ? <AdminProjectsPage /> :
      path === "/admin/paywall" ? <AdminPaywallPage /> :
      path === "/admin/plans" ? <AdminPlansPage /> :
      path === "/admin/point-packages" ? <AdminPointPackagesPage /> :
      path === "/admin/checkin" ? <AdminCheckinPage /> :
      path === "/admin/announcements" ? <AdminAnnouncementsPage /> :
      path === "/admin/redeem-codes" ? <AdminRedeemCodesPage /> :
      path === "/admin/inbox-send" ? <AdminInboxSendPage /> :
      path === "/admin/users" ? <AdminUsersPage /> :
      path === "/admin/api-keys" ? <AdminApiKeysPage /> :
      path === "/admin/crawler-docs" ? <AdminCrawlerDocsPage /> :
      path === "/admin/analytics" ? <AdminAnalyticsPage /> :
      path === "/admin/settings" ? <AdminSettingsPage /> :
      path === "/admin/maintenance" ? <AdminMaintenancePage /> :
      <NotFound />;
    return <AdminGuard>{inner}</AdminGuard>;
  }

  let m = match("/c/:slug", path);
  if (m && m.slug) return <CategoryListPage slug={m.slug} />;
  m = match("/p/:slug", path);
  if (m && m.slug) return <ProjectDetailPage slug={m.slug} />;

  return <NotFound />;
}

function NotFound() {
  return <div className="container mx-auto px-4 py-24 text-center">
    <h1 className="text-3xl font-bold">404</h1>
    <p className="text-muted-foreground mt-2">页面不存在</p>
  </div>;
}

export default App;
